import { CamsPayRepository } from './CamsPayRepository'

const resource = "/api/v1";
export default {
  instaNach(request) {
    return CamsPayRepository.post(`${resource}/instanach`, request);
  }
}
